import { CloudCode } from './cloudcode';

export interface NewProductDetails {
    name: string;
    description: string;
    sku: string;
    photoURL: string;
    otherDetails?: string;
    listPrice: number;
}

export interface ProductObj {
    id: string;
    name: string;
    description: string;
    sku: string;
    photoURL: string;
    subtotal: number;
    otherDetails: string;
    listPrice: number;
    currency: string;
    numSales: number;
    active: boolean;
}

export class ProductTasks {

    static pullBusinessProducts(
        successCallback: (activeProducts: ProductObj[]) => void,
        errorCallback: (msg: string) => void) {

        CloudCode.run('pullBusinessProducts',
        {},
        (activeProducts: ProductObj[]) => {
            successCallback(activeProducts);
        },
        (msg: string) => {
            errorCallback(msg);
        });
    }

    static addBusinessProduct(
        newProduct: NewProductDetails,
        successCallback: () => void,
        errorCallback: (msg: string) => void) {

        CloudCode.run('addBusinessProduct', newProduct,
        () => {
            successCallback();
        },
        (msg: string) => {
            errorCallback(msg);
        });
    }

    static editBusinessProduct(
        productID: string,
        newProduct: NewProductDetails,
        successCallback: () => void,
        errorCallback: (msg: string) => void) {

        CloudCode.run('editBusinessProduct', {
            productID,
            ...newProduct,
        },
        () => {
            successCallback();
        },
        (msg: string) => {
            errorCallback(msg);
        });
    }

    static activateBusinessProduct(
        productID: string,
        successCallback: () => void,
        errorCallback: (msg: string) => void) {

        CloudCode.run('activateBusinessProduct',
        {
            productID,
        },
        () => {
            successCallback();
        },
        (msg: string) => {
            errorCallback(msg);
        });
    }

    static deactivateBusinessProduct(
        productID: string,
        successCallback: () => void,
        errorCallback: (msg: string) => void) {

        CloudCode.run('deactivateBusinessProduct',
        {
            productID,
        },
        () => {
            successCallback();
        },
        (msg: string) => {
            errorCallback(msg);
        });
    }
}